module.exports = __webpack_public_path__ + "files/fef2a7d382852f6c00ba27b58068794f.png";